import { render, staticRenderFns } from "./RangeSliderQuestion.vue?vue&type=template&id=117be71f&scoped=true&"
import script from "./range-slider-question.js?vue&type=script&lang=js&"
export * from "./range-slider-question.js?vue&type=script&lang=js&"
import style0 from "./range-slider-question.scss?vue&type=style&index=0&id=117be71f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117be71f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117be71f')) {
      api.createRecord('117be71f', component.options)
    } else {
      api.reload('117be71f', component.options)
    }
    module.hot.accept("./RangeSliderQuestion.vue?vue&type=template&id=117be71f&scoped=true&", function () {
      api.rerender('117be71f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Builder/Questions/RangeSliderQuestion/RangeSliderQuestion.vue"
export default component.exports